module.exports = __webpack_public_path__ + "img/kuang5.adc3de8c.png";